import styled, { system } from '@xstyled/styled-components';
import { motion } from 'framer-motion';

export const Root = styled(motion.div)`
	display: flex;
	position: absolute;
	${system}
`;
